import { render } from "./logOutComponent.vue?vue&type=template&id=1bae8376"
import script from "./logOutComponent.vue?vue&type=script&lang=js"
export * from "./logOutComponent.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Agile-bot-web-dashboard/Agile-bot-web-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__